import { render, staticRenderFns } from "./CreateApplication.vue?vue&type=template&id=fc24a814&scoped=true&"
import script from "./CreateApplication.vue?vue&type=script&lang=ts&"
export * from "./CreateApplication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc24a814",
  null
  
)

export default component.exports